<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item">
                <div>地址格式</div>
                <div class="type-box">
                    <el-select v-model="dataList.addressFormat" class="m-2" style="width: 100%; height: 35px" placeholder="Select" size="large">
                        <el-option v-for="item in addressFormatList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="setting-content-item">
                <div>显示样式</div>
                <div class="type-box">
                    <el-select v-model="dataList.showStyle" class="m-2" style="width: 100%; height: 35px" placeholder="Select" size="large">
                        <el-option v-for="item in showStyleList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-city-setting">
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
    // 文本框是否可编辑
    noEdit: {
        type: Boolean,
        default: true,
    },
});
const addressFormatList = [
    { label: "包含省市区街道详细地址", value: "4" },
    { label: "包含省市区(如江苏省/南京市/玄武区)", value: "3" },
    { label: "包含省市(如江苏省/南京市)", value: "2" },
    { label: "包含省(如江苏省)", value: "1" },
];
const showStyleList = [
    { label: "每个层级一个选择框", value: "1" },
    { label: "所有层级一个选择框", value: "2" },
];
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
:deep(.el-radio) {
    margin-right: 60px;
}
:deep(.el-input-number) {
    width: 98px;
}
.type-box {
    display: flex;
    margin-top: 8px;
    .type-box1 {
        width: 98px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        opacity: 1;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 232, 238, 1);
        cursor: pointer;
        &:first-child {
            margin-right: 30px;
        }
    }
}

::deep(.el-select--large) {
    width: 230px;
    position: relative;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
</style>
